import { useContext } from 'react';

import * as SG from 'styles';

import { LayoutContext } from 'contexts';

import { Breadcrumb } from 'components/Breadcrumb';
import { Headline } from 'components/Headline';

import * as S from './Header.styles';
import { GridButtons } from './components/GridButtons';

export type HeaderProps = {
  isGridChange?: boolean;
};

const defaultProps: Partial<HeaderProps> = {
  isGridChange: false,
};

export function Header(props: HeaderProps): React.ReactElement {
  const { isGridChange } = { ...defaultProps, ...props };

  const { breadcrumb, breadcrumbSecondary, additionalInfo } = useContext(LayoutContext);

  const additionalInfoIntoHeadline = additionalInfo?.map((item) => (
    <Headline key={item} scale="lg" color="blackLight">
      {item}
    </Headline>
  ));

  return (
    <S.Wrapper data-testid="header">
      <SG.Inner>
        <S.Inner>
          <S.Container>
            <Breadcrumb breadcrumbs={breadcrumb} />
            {additionalInfo ? additionalInfoIntoHeadline : null}
            {isGridChange ? <GridButtons /> : null}
          </S.Container>

          <S.Container>
            <Breadcrumb asSecondaryMotive breadcrumbs={breadcrumbSecondary} />
          </S.Container>
        </S.Inner>
      </SG.Inner>
    </S.Wrapper>
  );
}
